<div class="one" fxLayout="column" [formGroup]="matterAddressForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTVOLUME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTVOLUME),
      }"
    >
      <mat-label>Volume</mat-label>
      <input matInput formControlName="PARENTVOLUME" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTFOLIOID),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTFOLIOID),
      }"
    >
      <mat-label>Folio Id</mat-label>
      <input matInput formControlName="PARENTFOLIOID" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTLOT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTLOT),
      }"
    >
      <mat-label>Lot</mat-label>
      <input matInput formControlName="PARENTLOT" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTPLANTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTPLANTYPE),
      }"
    >
      <mat-label>Plan Type</mat-label>
      <input matInput formControlName="PARENTPLANTYPE" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTPLANNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTPLANNUMBER),
      }"
    >
      <mat-label>Plan No.</mat-label>
      <input matInput formControlName="PARENTPLANNUMBER" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNALLOTMENT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNALLOTMENT),
      }"
    >
      <mat-label>Crown Allotment</mat-label>
      <input matInput formControlName="PARENTCROWNALLOTMENT" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNBLOCK),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNBLOCK),
      }"
    >
      <mat-label>Crown Block</mat-label>
      <input matInput formControlName="PARENTCROWNBLOCK" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNSECTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNSECTION),
      }"
    >
      <mat-label>Crown Section</mat-label>
      <input matInput formControlName="PARENTCROWNSECTION" />
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="25"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PARENTCROWNPORTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PARENTCROWNPORTION),
      }"
    >
      <mat-label>Crown Portion</mat-label>
      <input matInput formControlName="PARENTCROWNPORTION" />
    </mat-form-field>
  </div>
</div>
